var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartoon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1183px",
    height: "657px",
    viewBox: "0 0 1183 657",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61BFC4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#328B92",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.2108325%",
    y1: "8.36662175%",
    x2: "50%",
    y2: "91.6333782%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BDC1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D5D61",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93DDE0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB8BD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89D6DA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ADB3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93DDE0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB8BD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.0254393011,28.1606842 C0.666585157,43.0595696 13.2645842,54.6157066 28.158299,53.9745607 C43.0571843,53.3360001 54.6133213,40.7405864 53.9747607,25.841701 C53.3336149,10.9428157 40.7382011,-0.613321322 25.8393158,0.0252392684 C10.9404304,0.66897039 -0.615706554,13.2643841 0.0254393011,28.1606842",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93DDE0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB8BD",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(595.323241, 345.181205) scale(-1, 1) translate(-595.323241, -345.181205) translate(48.823241, 69.933286)",
    fill: "#EFF9FA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.036393,550.495837 C100.036393,550.495837 -101.427316,442.684792 67.4479919,299.845602 C197.666248,189.703228 -37.8354886,95.6837701 129.353193,24.8083544 C310.377403,-51.9323422 491.792193,78.9313342 742.979609,24.7105164 C981.201051,-26.7108493 1072.61475,112.481197 974.323064,216.598679 C897.482962,297.992751 1207.24652,321.358535 1045.55581,546.339508 L100.036393,550.495837",
    id: "Fill-3"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 177.5,
    y1: 297.5,
    x2: 1099.5,
    y2: 297.5,
    id: "Line",
    stroke: "#FF5555",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 50
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF5555",
    x: 172,
    y: 276,
    width: 7,
    height: 43,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FF5555",
    x: 1100,
    y: 276,
    width: 7,
    height: 43,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.94133,621.29324 L77.7324059,621.29324 C76.689396,621.29324 75.8358371,620.700499 75.8358371,619.979212 L75.8358371,617.472559 C75.8358371,616.747701 76.689396,616.158531 77.7324059,616.158531 L1077.94133,616.158531 C1078.98125,616.158531 1079.83584,616.747701 1079.83584,617.472559 L1079.83584,619.979212 C1079.83584,620.700499 1078.98125,621.29324 1077.94133,621.29324",
    id: "Fill-25",
    fill: "#2E3552",
    transform: "translate(577.835837, 618.725885) scale(-1, 1) translate(-577.835837, -618.725885) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.671842,210.955782 L177.075559,373.465114 L176.762801,373.497852 C171.133157,374.087415 166.0998,369.916042 165.521052,364.180879 L160.365087,313.094213 C155.762933,312.511713 151.839708,309.352613 150.207611,304.952549 L132.237174,358.78712 C130.144326,365.061863 131.146905,371.7239 134.996459,377.064169 C136.780908,379.541901 139.029319,381.511973 141.578763,382.890428 L168.90293,382.889067 C170.586562,382.889067 171.963281,384.265787 171.963281,385.949419 L171.963281,386.007878 C171.963281,387.69151 170.586562,389.068229 168.90293,389.068229 L167.148856,389.067782 L167.149147,392.955782 L150.704509,392.955782 C145.654889,392.955782 140.860425,391.593346 136.709058,389.069075 L99.2602072,389.068229 C97.5765755,389.068229 96.1998559,387.69151 96.1998559,386.007878 L96.1998559,385.949419 C96.1998559,384.265787 97.5765755,382.889067 99.2602072,382.889067 L129.664899,382.890131 C129.328373,382.474556 129.00184,382.047368 128.685763,381.608806 C123.439029,374.324468 122.009696,364.872454 124.862516,356.324808 L147.56816,288.295566 L148.125856,288.480782 L147.658772,283.849141 C147.050479,277.824026 150.665901,272.347951 156.064377,270.473879 L151.216029,222.44043 C150.63728,216.705267 154.732363,211.578082 160.362007,210.988519 L160.671842,210.955782 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.81001,616.158531 C219.81001,612.412835 222.845131,609.377715 226.590826,609.377715 L293.657938,609.377668 L282.084938,395.161668 L96.0079378,395.161668 L84.4359378,609.377668 L151.503319,609.377715 C155.169319,609.377715 158.154659,612.285055 158.280035,615.920431 L158.284135,616.158531 L80.8100104,616.158531 L92.7529378,395.161668 L65.9343501,395.162493 C63.4705465,395.162493 61.4709378,393.162884 61.4709378,390.69908 C61.4709378,388.235277 63.4705465,386.235668 65.9343501,386.235668 L308.976074,386.235668 C311.439877,386.235668 313.439486,388.235277 313.439486,390.69908 C313.439486,393.162884 311.439877,395.162493 308.976074,395.162493 L285.339938,395.161668 L297.284135,616.158531 L219.81001,616.158531 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(119.547073, 501.197727) scale(-1, 1) translate(-119.547073, -501.197727) translate(80.810010, 386.236923)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(219.810010, 386.236923)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(447.000000, 376.500000) scale(-1, 1) translate(-447.000000, -376.500000) translate(316.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-30",
    fill: "#F4BE99",
    points: "129 100.039711 105.510276 176.110078 104.297167 180.048687 101.391409 182.024473 41.1844103 223 31 209.063187 88.3167932 164.125716 84.1953342 170.04011 104.273838 93 129 100.039711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5247639,209.905234 C22.8461067,215.69425 22.1201657,225.79665 27.9065754,232.475268 C33.6929851,239.153887 43.795444,239.879823 50.476741,234.093447 C57.1553982,228.307071 57.8786994,218.202031 52.0922897,211.526053 C46.30588,204.844795 36.2007813,204.121498 29.5247639,209.905234",
    id: "Fill-31",
    fill: "#F4BE99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.791509,146 L130.622879,99.3339511 C132.50515,90.7710598 127.157729,82.2870406 118.678395,80.3809626 C110.199061,78.4801427 101.795227,83.8776299 99.9129553,92.4431503 L87,129.641907 L123.791509,146",
    id: "Fill-32",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-33",
    fill: "#F4BE99",
    points: "235.748208 409 252 426.653747 234.880129 439 219 421.563307 235.748208 409"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-34",
    fill: "#F4BE99",
    points: "70 448.550505 63.311417 471 44 463.030303 50.6963066 441 70 448.550505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,254.799927 L126.144743,316.432587 C128.976818,328.771055 133.908849,340.533469 140.721982,351.213834 L219.754331,431 L249,412.062852 L175.389499,319.375136 L151.922618,210 L112,254.799927",
    id: "Fill-35",
    fill: "#131614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12205,420.220355 C248.914815,419.605968 247.451108,420.33374 247.225723,421.69172 C246.785315,424.352306 245.365649,428.415699 240.982299,431.862068 C236.430558,435.44819 232.858076,434.707234 230.839973,433.673587 C229.777814,433.127758 228.49027,433.547018 228.011003,434.657133 L212.731453,470.228299 C211.801416,472.387883 211.757375,474.834884 212.604512,477.031384 C213.402427,479.093404 216.003421,479.665601 217.565573,478.123042 L260.743643,435.503564 C262.443097,433.826524 262.4146,431.044643 260.681467,429.404519 L252.166059,421.35684 C252.026165,421.22236 251.865545,421.108975 251.694564,421.021959 L250.12205,420.220355",
    id: "Fill-36",
    fill: "#0B1619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,197 L161,194.206153 L156.719731,96.361839 C156.105251,82.3147803 144.031887,71.4195547 129.751139,72.0239803 L128.203069,72.091427 C106.888756,72.9915801 97.8693359,90.4005941 98.7871014,111.366121 L95,197",
    id: "Fill-37",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0196727,195.803707 L41,450.383922 L73.3010958,461 L109.748513,325.357345 L151.446718,239.103664 C153.465047,235.250845 155.431155,231.213195 157.068274,227.063605 C160.16757,219.204375 161.350369,210.72557 160.911715,202.291021 L160.363398,193 L95.0196727,195.803707",
    id: "Fill-38",
    fill: "#282928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8518652,468.337942 C67.7403907,467.015283 66.368996,466.154666 65.1142606,466.644634 C62.648861,467.60426 58.4931979,468.43949 53.3213029,466.489773 C47.9497908,464.466435 46.7132024,461.105205 46.5369172,458.894004 C46.4435898,457.731282 45.4221729,456.863049 44.2426179,457.01791 L6.4113074,461.973439 C4.11441566,462.273004 2.0326955,463.458574 0.6275992,465.263585 C-0.694539385,466.96197 0.173924196,469.427041 2.28156865,469.965244 L60.5178847,484.867373 C62.8069991,485.453811 65.1324076,484.03722 65.6094144,481.767628 L67.9607472,470.61515 C67.9970412,470.432364 68.0100033,470.241962 67.9918563,470.054099 L67.8518652,468.337942",
    id: "Fill-39",
    fill: "#0B1619"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-40",
    fill: "#F4BE99",
    points: "152.703563 87 202 155.338636 198.131152 232 180.731795 231.710672 179.474419 158.495173 181.725148 165.384296 132 102.558522 152.703563 87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.035829,233.058646 C180.616632,241.876297 188.240996,248.550255 197.058646,247.964171 C205.876297,247.383368 212.550255,239.759004 211.964171,230.941354 C211.383368,222.123703 203.759004,215.449745 194.941354,216.035829 C186.123703,216.616632 179.449745,224.240996 180.035829,233.058646",
    id: "Fill-41",
    fill: "#F4BE99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,118.24191 L155.509381,84.595067 C149.9276,77.9135363 140.071622,77.101344 133.502692,82.7788051 C126.931178,88.4588947 126.132673,98.4811907 131.717039,105.16535 L153.139709,138 L188,118.24191",
    id: "Fill-42",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.871654,84.9903776 L120.965707,84.8996869 C127.904211,84.6042945 133.285198,78.7689994 132.98828,71.8661457 L131.003618,26 L106,27.0701496 L108.078426,75.1361912 C108.320648,80.8237902 113.154681,85.2339467 118.871654,84.9903776",
    id: "Fill-43",
    fill: "#F4BE99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.870522,54 C116.870522,54 118.847174,66.4860209 107.354065,71 L107,62.6528638 L116.870522,54",
    id: "Fill-44",
    fill: "#F2B28E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0254393,28.1606842 C87.6665852,43.0595696 100.264584,54.6157066 115.158299,53.9745607 C130.057184,53.3360001 141.613321,40.7405864 140.974761,25.841701 C140.333615,10.9428157 127.738201,-0.613321322 112.839316,0.0252392684 C97.9404304,0.66897039 86.3842934,13.2643841 87.0254393,28.1606842",
    id: "Fill-45",
    fill: "#F4BE99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.542903,65.9830177 L106.542903,65.9830177 C113.724821,65.6717632 119.295008,59.5706469 118.987886,52.3537623 L117.861774,26 L87,27.3347016 L87.9187396,48.8112638 C88.3413597,58.7212914 96.6808899,66.4103332 106.542903,65.9830177",
    id: "Fill-46",
    fill: "#F4BE99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6161318,34 L82.2392332,43.6229117 C81.483343,45.1821798 82.6146586,47.0059666 84.2876955,46.9252188 L91,48 L87.6161318,34",
    id: "Fill-47",
    fill: "#F4BE99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    transform: "translate(87.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8517443,38.8507573 C24.8517443,38.8507573 15.9377487,35.6269311 20.3559676,21.6380592 C20.3559676,21.6380592 1.0983245,24.6809168 -3.36384383,18.1815592 C-3.36384383,18.1815592 11.2635886,-20.4965986 41.9687875,-5.50981427 C72.6765717,9.47955537 60.373293,44.3108381 60.373293,44.3108381 L35.9011693,52.4906183 L24.8517443,38.8507573",
    id: "Fill-48",
    fill: "#061216",
    mask: "url(#mask-7)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.007039,39.8216597 C111.184758,43.9614745 114.684261,47.1682628 118.821463,46.993157 C122.961278,46.8154377 126.170681,43.3159352 125.992961,39.1787339 C125.815242,35.0389192 122.315739,31.8269038 118.175924,32.0072367 C114.038722,32.184956 110.829319,35.6844585 111.007039,39.8216597",
    id: "Fill-51",
    fill: "#F4BE99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,42 L131.913978,55.4706976 C131.913978,55.4706976 117.572581,59.3708213 117,45.9974241 L125.666667,47.1974622 L132,42",
    id: "Fill-52",
    fill: "#061216"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-53",
    fill: "url(#linearGradient-8)",
    points: "143 74.771366 132.452778 65 107 72.0536888 107.611055 85.8849525 125.861744 93 143 74.771366"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-54",
    fill: "#06131E",
    points: "94 200 161 197.190249 160.818307 193 94.9189986 195.763563 94 200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartoon1);
export default __webpack_public_path__ + "static/media/cartoon1.8d4a090f7456704117c1cd2b2d69a225.svg";
export { ForwardRef as ReactComponent };